
export default function NavbarContainer({ children }) {

    return (
        <div className="w-full fixed top-0 left-0 z-40">

            <div className="py-4 px-4 lg:px-0 bg-gray-100 dark:bg-black w-full">

                <div className="w-full flex lg:w-[70%] lg:px-10 mx-auto justify-between items-center">

                    {children}

                </div>

            </div>

        </div>
    );
}